import React, { useState, useEffect, useRef } from 'react'
import {
	Card,
	Col,
	Row,
	Button,
	Form,
	Input,
	Radio,
	InputNumber,
	Checkbox,
	Modal,
	message,
	Table,
	// Select,
	Typography,
	Timeline
} from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import LoadingBar from 'react-top-loading-bar'
import IntlMessages from 'util/IntlMessages'
import Banner from './../../../containers/Banner'

import Zakat from './Zakat'
import Sadaqah from './Sadaqah'
import Orphan from './Orphan'
import General from './General'
import Monthly from './Monthly'
import Winter from './Winter'
import Flood from './Flood'
import Qurbani from './Qurbani'
import Iftar from './Iftar'
import SelfReliant from './SelfReliant'
import TreePlantation from './TreePlantation'
import Complex from './Complex'
import Emergency from './Emergency'
import SkillDevelopment from './SkillDevelopment'
import ZakatBankAccount1 from '../BankAccounts/ZakatBankAccount1'
import ZakatBankAccount2 from '../BankAccounts/ZakatBankAccount2'
import EmergencyBankAccount1 from '../BankAccounts/EmergencyBankAccount1'
import ProductService from './../../../services/Product'
import UserProductService from './../../../services/UserProduct'
import DimensionService from './../../../services/Dimensions'
import ZakatPaymentMethod from '../PymentMethod/ZakatPaymentMethod'
import { Link } from 'react-router-dom'
import MonthlyTab from './Monthly/MonthlyTab'
import bkash from '../../../assets/images/payment/bkash_logo.svg'
import ssl from '../../../assets/images/payment/ssl.png'
import ComplexBankAccount1 from '../BankAccounts/ComplexBankAccount1'
// import FloodBankAccount1 from '../BankAccounts/FloodBankAccount1'
// import FloodBankAccount2 from '../BankAccounts/FloodBankAccount2'
// import QurbaniBankAccount1 from '../BankAccounts/QurbaniBankAccount1'
//import { SelectionState } from 'react-draft-wysiwyg'

const RadioButton = Radio.Button
const RadioGroup = Radio.Group

const { Paragraph } = Typography
const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 8 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 16 }
	}
}

const styles = {
	productRow: {
		borderRadius: '5px',
		background: '#eee',
		marginBottom: '10px'
	}
}

// const phoneRegex = new RegExp(/(^(\+88)?(01){1}[3456789]{1}(\d){8})$/)
// // eslint-disable-next-line no-useless-escape
// const emailRegex = new RegExp(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/)
// const phoneOrEmailRegex = new RegExp(
// 	phoneRegex.source + '|' + emailRegex.source
// )

// const phoneRegex = /^(\+88)?(01)[3456789]\d{8}$/
// const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
// const phoneOrEmailRegex = new RegExp(
// 	`^(${phoneRegex.source})|(${emailRegex.source})$`
// )

const phoneRegex = /^(\+88)?(01)[3456789]\d{8}$/
// eslint-disable-next-line no-useless-escape
const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,13}$/
const phoneOrEmailRegex = new RegExp(
	`^(${phoneRegex.source})$|^(${emailRegex.source})$`
)

// const phoneRegex = /^(\+88)?(01)[3456789]\d{8}$/
// const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/
// const phoneOrEmailRegex = new RegExp(
// 	`^(${phoneRegex.source})$|^(${emailRegex.source})$`
// )

const Donate = ({ intl }) => {
	const loadingRef = useRef(null)
	const [loading, setLoading] = useState(true)
	let { routeExtension } = useParams()
	const { width } = DimensionService.useDimensions()
	const [product, setProduct] = useState({})
	const [amount, setAmount] = useState('')
	const [videoId, setVideoId] = useState('')
	const [checked, setChecked] = useState(false)
	const [ayathId, setAyathId] = useState('')
	const [index, setIndex] = useState(undefined)
	const [isZakatPaymentNextActive, setIsZakatPaymentNextActive] =
		useState(false)
	const [paymentInfo, setPaymentInfo] = useState(null)
	const [isNextButtonActive] = useState(false)
	const [amountFieldError, setAmountFieldError] = useState(false)
	const [phoneFieldError, setPhoneFieldError] = useState(false)
	const [cowQurbaniNameList, setCowQurbaniNameList] = useState([])
	const [isCowQurbaniNamesFormOpen, setIsCowQurbaniNamesFormOpen] =
		useState(false)
	const [isUpdateCowQurbaniNamesFields, setIsUpdateCowQurbaniNamesFields] =
		useState(false)
	const [sharedCowQurbaniNameList, setSharedCowQurbaniNameList] = useState([])
	const [isSharedCowQurbaniNamesFormOpen, setIsSharedCowQurbaniNamesFormOpen] =
		useState(false)
	const [
		isUpdateSharedCowQurbaniNamesFields,
		setIsUpdateSharedCowQurbaniNamesFields
	] = useState(false)
	const [goatQurbaniNameList, setGoatQurbaniNameList] = useState([])
	const [isGoatQurbaniNamesFormOpen, setIsGoatQurbaniNamesFormOpen] =
		useState(false)
	const [isUpdateGoatQurbaniNamesFields, setIsUpdateGoatQurbaniNamesFields] =
		useState(false)
	//const [anonymity, setAnonymity] = useState(false)
	const [disableAmountField, setDisableAmountField] = useState(true)
	const [isHalal] = useState(false)
	const [donationMessage, setDonationMessage] = useState('')
	var [cowIncrement, setCowIncrement] = useState(0)
	var [sharedCowIncrement, setSharedCowIncrement] = useState(0)
	var [goatIncrement, setGoatIncrement] = useState(0)
	const history = useHistory()
	const [form] = Form.useForm()
	const [cowQurbaniNamesForm] = Form.useForm()
	const [sharedCowQurbaniNamesForm] = Form.useForm()
	const [goatQurbaniNamesForm] = Form.useForm()
	// eslint-disable-next-line
	const [modal, modalContext] = Modal.useModal()
	const cowPrice = 91000
	const sharedCowPrice = 13000
	const chagolPrice = 15000
	// const [subscriptionFrequencies, setSubscriptionFrequencies] = useState([])
	// const gateway = Form.useWatch('gateway', form)
	const [selectedSubscription, setSelectedSubscription] =
		React.useState('THIRTY_DAYS')
	const [initialDonationAmount, setInitialDonationAmount] = useState(300)

	const [selectedMonthlyGateway, setSelectedMonthlyGateway] =
		useState('bkash_recurring')

	// const frequencies = [
	// 	'DAILY',
	// 	'WEEKLY',
	// 	// 'FIFTEEN_DAYS',
	// 	'THIRTY_DAYS',
	// 	// 'NINETY_DAYS',
	// 	// 'ONE_EIGHTY_DAYS',
	// 	// 'CALENDAR_MONTH',
	// 	'CALENDAR_YEAR'
	// ]

	const donations = [
		{
			amount: 1,
			value: '1',
			message: ''
		},
		{
			amount: 10,
			value: '10',
			message: ''
		},
		{
			amount: 20,
			value: '20',
			message: ''
		},
		{
			amount: 50,
			value: '50',
			message: ''
		},
		{
			amount: 100,
			value: '100',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.1' })
		},
		{
			amount: 200,
			value: '200',
			message: ''
		},
		{
			amount: 1000,
			value: '1000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.2' })
		},
		{
			amount: 50000,
			value: '50000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.5' })
		},
		{
			amount: 700,
			value: '700',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.11' })
		},
		{
			amount: 1400,
			value: '1400',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.7' })
		},
		{
			amount: 2100,
			value: '2100',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.8' })
		},
		{
			amount: 2800,
			value: '2800',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.9' })
		},
		{
			amount: 3500,
			value: '3500',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.10' })
		},
		{
			amount: 300,
			value: '300',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.12' })
		},
		{
			amount: 500,
			value: '500',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.13' })
		},
		{
			amount: 1000,
			value: '1000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.14' })
		},
		{
			amount: 2000,
			value: '2000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.14' })
		},
		{
			amount: 10,
			value: '0',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.6' })
		},
		{
			amount: 30000,
			value: '30000',
			message: ''
		},
		{
			amount: 9000,
			value: '9000',
			message: ''
		},
		{
			amount: 63000,
			value: '63000',
			message: ''
		},
		{
			amount: 450,
			value: '450',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.15' })
		},
		{
			amount: 900,
			value: '900',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.16' })
		},
		{
			amount: 1350,
			value: '1350',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.17' })
		},
		{
			amount: 1800,
			value: '1800',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.18' })
		},
		{
			amount: 2250,
			value: '2250',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.19' })
		},
		{
			amount: 8000,
			value: '8000',
			message: ''
		},
		{
			amount: 16000,
			value: '16000',
			message: ''
		},
		{
			amount: 24000,
			value: '24000',
			message: ''
		},
		{
			amount: 32000,
			value: '32000',
			message: ''
		},
		{
			amount: 40000,
			value: '40000',
			message: ''
		},
		{
			amount: 48000,
			value: '48000',
			message: ''
		},
		{
			amount: 50000,
			value: '50000',
			message: ''
		},
		{
			amount: 100000,
			value: '100000',
			message: ''
		},
		{
			amount: 2500,
			value: '2500',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.2500' })
		},
		{
			amount: 5000,
			value: '5000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.5000' })
		},
		{
			amount: 7500,
			value: '7500',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.7500' })
		},
		{
			amount: 10000,
			value: '10000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.10000'
			})
		},
		{
			amount: 12500,
			value: '12500',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.12500'
			})
		},
		{
			amount: 15000,
			value: '15000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.15000'
			})
		},
		{
			amount: 17500,
			value: '17500',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.17500'
			})
		},
		{
			amount: 4000,
			value: '4000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.4000'
			})
		},
		{
			amount: 8000,
			value: '8000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.8000'
			})
		},
		{
			amount: 12000,
			value: '12000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.12000'
			})
		},
		{
			amount: 16000,
			value: '16000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.16000'
			})
		},
		{
			amount: 20000,
			value: '20000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.20000'
			})
		},
		{
			amount: 24000,
			value: '24000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.24000'
			})
		},
		{
			amount: 28000,
			value: '28000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.28000'
			})
		},
		{
			amount: 32000,
			value: '32000',
			message: intl.formatMessage({
				id: 'payment.info.amount.suggestion.32000'
			})
		},
		{
			amount: 750,
			value: '750',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.750' })
		},
		{
			amount: 1500,
			value: '1500',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.1500' })
		},
		{
			amount: 2250,
			value: '2250',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.2250' })
		},
		{
			amount: 3000,
			value: '3000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.3000' })
		},
		{
			amount: 3750,
			value: '3750',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.3750' })
		},
		{
			amount: 1200,
			value: '1200',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.1200' })
		},
		{
			amount: 2400,
			value: '2400',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.2400' })
		},
		{
			amount: 3600,
			value: '3600',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.3600' })
		},
		{
			amount: 4800,
			value: '4800',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.4800' })
		},
		{
			amount: 6000,
			value: '6000',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.6000' })
		},
		{
			amount: 600,
			value: '600',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.600' })
		},
		{
			amount: 1200,
			value: '1200',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.1200' })
		},
		{
			amount: 1800,
			value: '1800',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.1800' })
		},
		{
			amount: 2400,
			value: '2400',
			message: intl.formatMessage({ id: 'payment.info.amount.suggestion.2400' })
		},
		{
			amount: 4500,
			value: '4500',
			message: ''
		},
		{
			amount: 60000,
			value: '60000',
			message: ''
		},
		{
			amount: 120000,
			value: '120000',
			message: ''
		},
		{
			amount: 36000,
			value: '36000',
			message: ''
		}
	]

	const user = JSON.parse(localStorage.getItem('user'))
	if (user) {
		form.setFieldsValue({
			phoneOrEmail: user.id,
			donorName: user?.fullname ? user?.fullname : null
			// donorName: user.fullname
		})
	}

	// console.log('user', user)

	const switchVideoId = product => {
		const thisVideoId =
			product.name === 'donation.product.zakat.title'
				? 'TEEjg43HRBM'
				: product.name === 'donation.product.sadaqah.title'
					? '56cBlOKUkyc'
					: product.name === 'donation.product.general.title'
						? 'ZW78m-HRZbg'
						: product.name === 'donation.product.monthly.title'
							? 'ZW78m-HRZbg'
							: product.name === 'donation.product.orphan.title'
								? 'ZW78m-HRZbg'
								: product.name === 'donation.product.flood.title'
									? '6zKj8L6mGTM'
									: product.name === 'donation.product.winter.title'
										? 'zx0TWzkd524'
										: product.name === 'donation.product.qurbani.title'
											? 'VCCAxvPhXK0'
											: product.name === 'donation.product.iftar.title'
												? '8YMNH2zM1SE'
												: product.name === 'donation.product.self-reliant.title'
													? 'T_qg3QFcmIc'
													: product.name === 'donation.product.tree-plantation.title'
														? 'KVjKMEAerhQ'
														: product.name === 'donation.product.complex.title'
															? 'V4RvEgSaaMk'
															: product.name === 'donation.product.skill-development-institute.title'
																? '_DEcAsk-4Iw'
																: 'ZW78m-HRZbg'
		setVideoId(thisVideoId)
	}

	const updateProductStorage = () => {
		loadingRef.current.continuousStart()
		ProductService.getAll().then(
			res => {
				loadingRef.current.complete()
				// console.log(res)
				if (res.state === 'success') {
					setLoading(false)
					localStorage.setItem('products', JSON.stringify(res.products))
					const product = JSON.parse(localStorage.getItem('products')).find(
						item => item.routeExtension === '/' + routeExtension
					)
					if (product) {
						setProduct(product)
						switchVideoId(product)
						setAyathId(product.name.split('.')[2] + '.ayath.')
						// if (product.name === 'donation.product.iftar.title') {
						// 	setAmount(700)
						// 	setDonationMessage(intl.formatMessage({ id: 'payment.info.amount.suggestion.11' }))
						// } else {
						// 	setAmount(100)
						// 	setDonationMessage(intl.formatMessage({ id: 'payment.info.amount.suggestion.1' }))
						// }
					} else {
						history.push('/error404')
					}
				} else {
					message.warning(intl.formatMessage({ id: res.message }))
				}
			},
			err => {
				loadingRef.current.complete()
				console.error(err)
				message.error(intl.formatMessage({ id: 'backend.network.error' }))
			}
		)
	}

	// useEffect(() => {
	// 	setInitialDonationAmount(
	// 		product.name === 'donation.product.monthly.title' ? 300 : 10
	// 	)
	// }, [product.name])

	useEffect(() => {
		if (routeExtension.length < 2) {
			history.push('/error404')
		}
		if (localStorage.getItem('products')) {
			const product = JSON.parse(localStorage.getItem('products')).find(
				item => item.routeExtension === '/' + routeExtension
			)
			if (product) {
				setLoading(false)
				setProduct(product)
				switchVideoId(product)
				setAyathId(product.name.split('.')[2] + '.ayath.')
				// if (product.name === 'donation.product.iftar.title') {
				// 	setAmount(700)
				// 	setDonationMessage(intl.formatMessage({ id: 'payment.info.amount.suggestion.11' }))
				// } else {
				// 	setAmount(100)
				// 	setDonationMessage(intl.formatMessage({ id: 'payment.info.amount.suggestion.1' }))
				// }
			} else {
				updateProductStorage()
			}
		} else {
			updateProductStorage()
		}
		// setSubscriptionFrequencies(
		// 	frequencies.map(f => {
		// 		return { value: f, label: f.replaceAll('_', ' ') }
		// 	})
		// )
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	// console.log(cowIncrement)
	// console.log('hellow')

	// console.log('cow', {
	// 	cowIncrement,
	// 	sharedCowIncrement,
	// 	goatIncrement
	// })

	useEffect(() => {
		if (product.name === 'donation.product.monthly.title') {
			form.setFieldValue('gateway', 'bkash_recurring')
			setSelectedMonthlyGateway('bkash_recurring')
		}
	}, [form, selectedSubscription, product.name])

	// console.log(form.getFieldValue('gateway'))

	const purchaseUsingServerAmount = (values, res) => {
		setLoading(true)
		loadingRef.current.continuousStart()
		var qurbaniNameList = []
		if (cowQurbaniNameList && cowQurbaniNameList.length > 0) {
			qurbaniNameList.push(
				...cowQurbaniNameList.map(item => {
					item.animalName = 'Cow'
					return item
				})
			)
		}
		if (sharedCowQurbaniNameList && sharedCowQurbaniNameList.length > 0) {
			qurbaniNameList.push(
				...sharedCowQurbaniNameList.map(item => {
					item.animalName = 'SharedCow'
					return item
				})
			)
		}
		if (goatQurbaniNameList && goatQurbaniNameList.length > 0) {
			qurbaniNameList.push(
				...goatQurbaniNameList.map(item => {
					item.animalName = 'Goat'
					return item
				})
			)
		}

		UserProductService.purchase(
			product._id,
			values.gateway === 'bkash_recurring' ? values.amount : res.amount,
			values.phoneOrEmail,
			values.donorName,
			cowIncrement > 0 || sharedCowIncrement > 0 || goatIncrement > 0
				? {
					numberOfCows: cowIncrement,
					numberOfSharedCows: sharedCowIncrement,
					numberOfGoats: goatIncrement,
					isFullCow: cowIncrement > 0 ? 1 : 0,
					isSharedCow: sharedCowIncrement > 0 ? 1 : 0,
					isGoat: goatIncrement > 0 ? 1 : 0,
					isHalalContribution: isHalal ? 1 : 0
				}
				: undefined,
			qurbaniNameList,
			values.gateway,
			values.subscription
		).then(
			res => {
				setLoading(false)
				loadingRef.current.complete()
				console.log('response', res)
				if (res.state === 'success') {
					window.location.href = res.paymentGatewayUrl
				} else {
					window.alert(res.message)
					// console.log('pass')
					if (res.message !== undefined && res.message.reason !== undefined) {
						message.warning(res.message.reason)
					} else {
						message.warning(intl.formatMessage({ id: res.message }))
					}
				}
			},
			err => {
				setLoading(false)
				loadingRef.current.complete()
				console.error(err)
				message.error(intl.formatMessage({ id: 'backend.network.error' }))
			}
		)
	}

	const onSubmit = formValues => {
		// console.log(formValues)
		// const subscription = selectedSubscription.replaceAll('_', '')

		// const values = {
		// 	...formValues,
		// 	// gateway:
		// 	// 	product.name === 'donation.product.monthly.title'
		// 	// 		? 'bkash_recurring'
		// 	// 		: product.name !== 'donation.product.zakat.title'
		// 	// 		? 'sslcommerz'
		// 	// 		: undefined,
		// 	// gateway: formValues.gateway ? formValues.gateway : 'sslcommerz',

		// 	...(product.name === 'donation.product.monthly.title' && {
		// 		subscription: selectedSubscription,
		// 		gateway: selectedMonthlyGateway
		// 	})
		// 	// ...((product.name !== 'donation.product.monthly.title' ||
		// 	// 	product.name !== 'donation.product.qurbani.title' ||
		// 	// 	product.name !== 'donation.product.zakat.title') && {
		// 	// 	gateway: 'sslcommerz'
		// 	// }),
		// 	// product.name !== 'donation.product.monthly.title' && {
		// 	// 	gateway: 'sslcommerz'
		// 	// },
		// 	// ...(product.name !== 'donation.product.qurbani.title' && {
		// 	// 	gateway: 'sslcommerz'
		// 	// }),
		// 	// ...(product.name !== 'donation.product.zakat.title' && {
		// 	// 	gateway: 'sslcommerz'
		// 	// })
		// }

		const values = {
			...formValues,

			// If the product name is 'donation.product.monthly.title', set specific values
			...(product.name === 'donation.product.monthly.title' && {
				subscription: selectedSubscription,
				gateway: selectedMonthlyGateway
			}),

			// No override for 'donation.product.qurbani.title' and 'donation.product.zakat.title'
			...(product.name !== 'donation.product.qurbani.title' &&
				product.name !== 'donation.product.zakat.title' &&
				product.name !== 'donation.product.monthly.title' && {
				gateway: formValues.gateway || 'sslcommerz'
			})
		}

		// monthly, qurbani, zakat

		// console.log('values', formValues)
		console.log('newNalues', values)

		// console.log(cowIncrement)
		// console.log('hellow')

		// console.log('cow', {
		// 	cowIncrement,
		// 	sharedCowIncrement,
		// 	goatIncrement
		// })

		// const productDetails = {
		// 	product_id: product._id,
		// 	// amount: values.gateway === 'bkash_recurring' ? values.amount : res.amount,
		// 	phoneOrEmail: values.phoneOrEmail,
		// 	donorName: values.donorName,
		// 	animals:
		// 		cowIncrement > 0 || sharedCowIncrement > 0 || goatIncrement > 0
		// 			? {
		// 					numberOfCows: cowIncrement,
		// 					numberOfSharedCows: sharedCowIncrement,
		// 					numberOfGoats: goatIncrement
		// 			  }
		// 			: undefined,
		// 	// qurbaniNameList: qurbaniNameList,
		// 	gateway: values.gateway,
		// 	subscription: values.subscription
		// }

		// console.log('test', productDetails)

		// submit main logic starts here

		if (!loading) {
			if (/(^(01){1}[3456789]{1}(\d){8})$/.test(values.phoneOrEmail)) {
				values.phoneOrEmail = '+88' + values.phoneOrEmail
			}
			setLoading(true)
			loadingRef.current.continuousStart()
			ProductService.getAmount(product._id, values.phoneOrEmail).then(
				res => {
					setLoading(false)
					console.log('product service', res)
					loadingRef.current.complete()
					if (res.state === 'success' && res.amount) {
						if (selectedMonthlyGateway !== 'bkash_recurring') {
							modal.confirm({
								title:
									intl.formatMessage({
										id: 'donation.product.monthly.onConfirm.title.text.1'
									}) +
									' ' +
									res.amount +
									' ' +
									intl.formatMessage({
										id: 'donation.product.monthly.onConfirm.title.text.2'
									}),
								content:
									intl.formatMessage({
										id: 'donation.product.monthly.onConfirm.inner.text.1'
									}) +
									' ' +
									res.amount +
									' ' +
									intl.formatMessage({
										id: 'donation.product.monthly.onConfirm.inner.text.2'
									}),
								centered: true,
								okText: intl.formatMessage({
									id: 'donation.product.monthly.onConfirm.okButton.text'
								}),
								cancelText: intl.formatMessage({
									id: 'donation.product.monthly.onConfirm.cancelButton.text'
								}),
								onOk: () => {
									purchaseUsingServerAmount(values, res)
								},
								onCancel: () => { }
							})
						} else {
							purchaseUsingServerAmount(values, res)
						}
					} else {
						setLoading(true)
						console.log('else')
						loadingRef.current.continuousStart()
						var qurbaniNameListElse = []
						if (cowQurbaniNameList && cowQurbaniNameList.length > 0) {
							qurbaniNameListElse.push(
								...cowQurbaniNameList.map(item => {
									item.animalName = 'Cow'
									return item
								})
							)
						}
						if (
							sharedCowQurbaniNameList &&
							sharedCowQurbaniNameList.length > 0
						) {
							qurbaniNameListElse.push(
								...sharedCowQurbaniNameList.map(item => {
									item.animalName = 'SharedCow'
									return item
								})
							)
						}
						if (goatQurbaniNameList && goatQurbaniNameList.length > 0) {
							qurbaniNameListElse.push(
								...goatQurbaniNameList.map(item => {
									item.animalName = 'Goat'
									return item
								})
							)
						}
						UserProductService.purchase(
							product._id,
							values.amount,
							values.phoneOrEmail,
							values.donorName,
							cowIncrement > 0 || sharedCowIncrement > 0 || goatIncrement > 0
								? {
									numberOfCows: cowIncrement,
									numberOfSharedCows: sharedCowIncrement,
									numberOfGoats: goatIncrement,
									isFullCow: cowIncrement > 0 ? 1 : 0,
									isSharedCow: sharedCowIncrement > 0 ? 1 : 0,
									isGoat: goatIncrement > 0 ? 1 : 0,
									isHalalContribution: isHalal ? 1 : 0
								}
								: undefined,
							qurbaniNameListElse,
							values.gateway,
							values.subscription
						).then(
							res => {
								setLoading(false)
								loadingRef.current.complete()
								console.log('ress', res)
								if (res.state === 'success') {
									window.location.href = res.paymentGatewayUrl
								} else {
									if (
										res.message !== undefined &&
										res.message.reason !== undefined
									) {
										message.warning(res.message.reason)
									} else {
										message.warning(intl.formatMessage({ id: res.message }))
									}
								}
							},
							err => {
								setLoading(false)
								loadingRef.current.complete()
								console.error(err)
								message.error(
									intl.formatMessage({ id: 'backend.network.error' })
								)
							}
						)
					}
				},
				err => {
					var qurbaniNameList = []
					if (cowQurbaniNameList && cowQurbaniNameList.length > 0) {
						qurbaniNameList.push(
							...cowQurbaniNameList.map(item => {
								item.animalName = 'Cow'
								return item
							})
						)
					}
					if (sharedCowQurbaniNameList && sharedCowQurbaniNameList.length > 0) {
						qurbaniNameList.push(
							...sharedCowQurbaniNameList.map(item => {
								item.animalName = 'SharedCow'
								return item
							})
						)
					}
					if (goatQurbaniNameList && goatQurbaniNameList.length > 0) {
						qurbaniNameList.push(
							...goatQurbaniNameList.map(item => {
								item.animalName = 'Goat'
								return item
							})
						)
					}
					UserProductService.purchase(
						product._id,
						values.amount,
						values.phoneOrEmail,
						values.donorName,
						cowIncrement > 0 || sharedCowIncrement > 0 || goatIncrement > 0
							? {
								numberOfCows: cowIncrement,
								numberOfSharedCows: sharedCowIncrement,
								numberOfGoats: goatIncrement,
								isFullCow: cowIncrement > 0 ? 1 : 0,
								isSharedCow: sharedCowIncrement > 0 ? 1 : 0,
								isGoat: goatIncrement > 0 ? 1 : 0,
								isHalalContribution: isHalal ? 1 : 0
							}
							: undefined,
						qurbaniNameList,
						values.gateway,
						values.subscription
					).then(
						res => {
							console.log('ress', res)
							setLoading(false)
							loadingRef.current.complete()
							if (res.state === 'success') {
								window.location.href = res.paymentGatewayUrl
							} else {
								message.warning(intl.formatMessage({ id: res.message }))
							}
						},
						err => {
							setLoading(false)
							loadingRef.current.complete()
							console.error(err)
							message.error(intl.formatMessage({ id: 'backend.network.error' }))
						}
					)
				}
			)
		}
	}

	// const onCheckBoxChange = () => {
	// 	if (anonymity) {
	// 		setAnonymity(false)
	// 	} else if (!anonymity) {
	// 		setAnonymity(true)
	// 	}
	// }

	const onSuggestionCheckBoxChange = () => {
		setCowIncrement(0)
		setSharedCowIncrement(0)
		setGoatIncrement(0)
		if (checked) {
			setChecked(false)
			setDisableAmountField(true)
			// console.log('chekced false')
		} else if (!checked) {
			setChecked(true)
			// console.log('chekced true')
			setDisableAmountField(false)
		}
	}

	const zakatFormNextHandler = () => {
		const values = form.getFieldsValue(true)

		if (!values.amount) {
			setAmountFieldError(true)
		}

		if (!values.phoneOrEmail) {
			setPhoneFieldError(true)
		}

		if (values.amount && values.phoneOrEmail) {
			setPaymentInfo(values)
			setIsZakatPaymentNextActive(true)
			window.scrollTo(0, 0)
		}
	}

	// const onHalalCheckBoxChange = event => {
	// 	setIsHalal(event.target.checked)
	// }

	const selectedAmount = value => {
		if (value === '0') {
			setDisableAmountField(false)
		} else {
			setDisableAmountField(true)
			setAmountFieldError(false)
		}
		setDonationMessage(donations.find(item => item.value === value).message)
		// setAmount(donations.find(item => item.value === value).amount)
		setAmount(value)
		form.setFieldsValue({
			amount: donations.find(item => item.value === value).amount
		})
	}

	const selectedIncrementAmount = () => {
		setChecked(false)
		setDisableAmountField(true)
		form.setFieldsValue({
			amount:
				cowPrice * cowIncrement +
				sharedCowPrice * sharedCowIncrement +
				chagolPrice * goatIncrement
		})
	}

	const handleDonationTabChange = (amount, tabValue) => {
		// console.log('amount --', amount)
		// console.log('value', tabValue)
		// setAmount(amount)
		setInitialDonationAmount(amount)

		// setInitialDonationAmount(selectedMonthlyGateway === 'bkash')
		setSelectedSubscription(tabValue)

		selectedAmount(amount.toString())

		form.setFieldsValue({
			amount: donations.find(item => item.amount === amount).amount
		})

		// console.log(
		// 	'ammmm',
		// 	donations.find(item => {
		// 		if (item.amount === amount) {
		// 			console.log(item)
		// 		}
		// 	})
		// )
	}

	var cowQurbaniNamesColumns = [
		{
			title: <IntlMessages id='payment.info.donorName' />,
			//width: 20,
			dataIndex: 'donorName',
			key: 'donorName'
		},
		{
			title: <IntlMessages id='payment.info.donor.fathersName' />,
			//width: 20,
			dataIndex: 'fathersName',
			key: 'fathersName'
		},
		{
			title: 'Action',
			//width: 20,
			dataIndex: '_id',
			render: (text, record, index) => {
				return (
					<span
						className='gx-link'
						onClick={() => {
							setIsUpdateCowQurbaniNamesFields(true)
							setIsCowQurbaniNamesFormOpen(true)
							cowQurbaniNamesForm.setFieldsValue(cowQurbaniNameList[index])
							setIndex(index)
						}}
					>
						<IntlMessages id='nav.volunteer.button.edit' />
					</span>
				)
			}
		},
		{
			//width: 20,
			dataIndex: 'active',
			render: (text, record, index) => {
				return (
					<span
						className='gx-link'
						onClick={() => {
							var temp1 = [...cowQurbaniNameList]
							temp1.splice(index, 1)
							setCowQurbaniNameList(temp1)
							if (cowQurbaniNameList.length === 1) {
								cowQurbaniNamesForm.resetFields()
								setIsUpdateCowQurbaniNamesFields(true)
								setIsCowQurbaniNamesFormOpen(true)
							}
							// if (cowQurbaniNameList.length === 1) {
							// 	setIsUpdateCowQurbaniNamesFields(true)
							// 	setIsCowQurbaniNamesFormOpen(true)
							// }
							// cowQurbaniNamesForm.setFieldsValue(cowQurbaniNameList[index])
							// setIndex(index)
						}}
					>
						<IntlMessages id='nav.volunteer.button.delete' />
					</span>
				)
			}
		}
	]

	var sharedCowQurbaniNamesColumns = [
		{
			title: <IntlMessages id='payment.info.donorName' />,
			//width: 20,
			dataIndex: 'donorName',
			key: 'donorName'
		},
		{
			title: <IntlMessages id='payment.info.donor.fathersName' />,
			//width: 20,
			dataIndex: 'fathersName',
			key: 'fathersName'
		},
		{
			title: 'Action',
			//width: 20,
			dataIndex: '_id',
			render: (text, record, index) => {
				return (
					<span
						className='gx-link'
						onClick={() => {
							setIsUpdateSharedCowQurbaniNamesFields(true)
							setIsSharedCowQurbaniNamesFormOpen(true)
							sharedCowQurbaniNamesForm.setFieldsValue(
								sharedCowQurbaniNameList[index]
							)
							setIndex(index)
						}}
					>
						<IntlMessages id='nav.volunteer.button.edit' />
					</span>
				)
			}
		},
		{
			//width: 20,
			dataIndex: 'active',
			render: (text, record, index) => {
				return (
					<span
						className='gx-link'
						onClick={() => {
							var temp1 = [...sharedCowQurbaniNameList]
							temp1.splice(index, 1)
							setSharedCowQurbaniNameList(temp1)
							if (sharedCowQurbaniNameList.length === 1) {
								sharedCowQurbaniNamesForm.resetFields()
								setIsUpdateSharedCowQurbaniNamesFields(true)
								setIsSharedCowQurbaniNamesFormOpen(true)
							}
						}}
					>
						<IntlMessages id='nav.volunteer.button.delete' />
					</span>
				)
			}
		}
	]

	var goatQurbaniNamesColumns = [
		{
			title: <IntlMessages id='payment.info.donorName' />,
			//width: 20,
			dataIndex: 'donorName',
			key: 'donorName'
		},
		{
			title: <IntlMessages id='payment.info.donor.fathersName' />,
			//width: 20,
			dataIndex: 'fathersName',
			key: 'fathersName'
		},
		{
			title: 'Action',
			//width: 20,
			dataIndex: '_id',
			render: (text, record, index) => {
				return (
					<span
						className='gx-link'
						onClick={() => {
							setIsUpdateGoatQurbaniNamesFields(true)
							setIsGoatQurbaniNamesFormOpen(true)
							goatQurbaniNamesForm.setFieldsValue(goatQurbaniNameList[index])
							setIndex(index)
						}}
					>
						<IntlMessages id='nav.volunteer.button.edit' />
					</span>
				)
			}
		},
		{
			//width: 20,
			dataIndex: 'active',
			render: (text, record, index) => {
				return (
					<span
						className='gx-link'
						onClick={() => {
							var temp1 = [...goatQurbaniNameList]
							temp1.splice(index, 1)
							setGoatQurbaniNameList(temp1)
							if (goatQurbaniNameList.length === 1) {
								goatQurbaniNamesForm.resetFields()
								setIsUpdateGoatQurbaniNamesFields(true)
								setIsGoatQurbaniNamesFormOpen(true)
							}
						}}
					>
						<IntlMessages id='nav.volunteer.button.delete' />
					</span>
				)
			}
		}
	]

	const onSubmitCowQurbaniNames = values => {
		// console.log(values)
		if (
			!isUpdateCowQurbaniNamesFields &&
			cowQurbaniNameList.length < cowIncrement * 7
		) {
			var temp2 = cowQurbaniNameList
			temp2.push(values)
			setCowQurbaniNameList(temp2)
			cowQurbaniNamesForm.resetFields()
		} else if (isUpdateCowQurbaniNamesFields) {
			cowQurbaniNameList.splice(index, 1, values)
			setCowQurbaniNameList(cowQurbaniNameList)
			setIsUpdateCowQurbaniNamesFields(false)
			cowQurbaniNamesForm.resetFields()
		}
		setIsCowQurbaniNamesFormOpen(false)
	}

	const onSubmitSharedCowQurbaniNames = values => {
		if (
			!isUpdateSharedCowQurbaniNamesFields &&
			sharedCowQurbaniNameList.length < sharedCowIncrement
		) {
			var temp2 = sharedCowQurbaniNameList
			temp2.push(values)
			setSharedCowQurbaniNameList(temp2)
			sharedCowQurbaniNamesForm.resetFields()
		} else if (isUpdateSharedCowQurbaniNamesFields) {
			sharedCowQurbaniNameList.splice(index, 1, values)
			setSharedCowQurbaniNameList(sharedCowQurbaniNameList)
			setIsUpdateSharedCowQurbaniNamesFields(false)
			sharedCowQurbaniNamesForm.resetFields()
		}
		setIsSharedCowQurbaniNamesFormOpen(false)
	}

	const onSubmitGoatQurbaniNames = values => {
		if (
			!isUpdateGoatQurbaniNamesFields &&
			goatQurbaniNameList.length < goatIncrement
		) {
			var temp2 = goatQurbaniNameList
			temp2.push(values)
			setGoatQurbaniNameList(temp2)
			goatQurbaniNamesForm.resetFields()
		} else if (isUpdateGoatQurbaniNamesFields) {
			goatQurbaniNameList.splice(index, 1, values)
			setGoatQurbaniNameList(goatQurbaniNameList)
			setIsUpdateGoatQurbaniNamesFields(false)
			goatQurbaniNamesForm.resetFields()
		}
		setIsGoatQurbaniNamesFormOpen(false)
	}

	// useEffect(() => {
	// 	if (product.name === 'donation.product.monthly.title') {
	// 		form.setFieldValue('gateway', 'bkash_recurring')
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [product.name])

	return (
		<div>
			<Banner
				title={
					<IntlMessages id={product.name ? product.name : 'donation.banner'} />
				}
			/>
			<div className='gx-main-content-wrapper'>
				<LoadingBar height={3} color='#0C8F4D' ref={loadingRef} />
				<Row>
					<Col
						xl={12}
						lg={12}
						md={24}
						sm={24}
						xs={24}
						style={{ marginTop: '20px' }}
					>
						<div className='youtube-container'>
							{/* <img alt='zakat' src={product.primaryBanner} /> */}
							<iframe
								className='youtube-frame'
								type='text/html'
								title={<IntlMessages id={product.name} />}
								src={
									'https://www.youtube.com/embed/' +
									videoId +
									'?modestbranding=1'
								}
								frameBorder='0'
								allowFullScreen
							></iframe>
						</div>
						<div>
							{product.name !== 'donation.product.monthly.title' &&
								product.name !== 'donation.product.qurbani.title' ? (
								<Card
									style={{ marginTop: '30px', width: '100%' }}
									className='gx-card'
								>
									<h2
										style={{
											paddingBottom: 0,
											textAlign: 'center',
											color: '#008E48'
										}}
									>
										<IntlMessages id={ayathId + '1'} />
									</h2>
									<h2
										style={{
											paddingBottom: 0,
											textAlign: 'center',
											color: '#008E48'
										}}
									>
										<IntlMessages id={ayathId + '2'} />
									</h2>
								</Card>
							) : null}

							{product.name === 'donation.product.monthly.title' && (
								<>
									<Card
										style={{ marginTop: '30px', width: '100%' }}
										className='gx-card'
									>
										<h2
											style={{
												paddingBottom: 0,
												textAlign: 'center',
												color: '#008E48'
											}}
										>
											<IntlMessages id={ayathId + '1'} />
										</h2>
									</Card>

									<Card
										style={{ marginTop: '30px', width: '100%' }}
										className='gx-card'
									>
										{/* <h2
											style={{
												paddingBottom: 0,
												textAlign: 'center',
												color: '#008E48'
											}}
										>
											<IntlMessages id='monthly.hadith.1' />
										</h2>
										<br /> */}
										<h2
											style={{
												paddingBottom: 0,
												textAlign: 'center',
												color: '#008E48'
											}}
										>
											<IntlMessages id='monthly.hadith.2' />
										</h2>
									</Card>

									<div className='monthly-card-xs'>
										<Card style={{ width: '100%' }} className='gx-card'>
											<Typography>
												<Paragraph>
													<IntlMessages id='monthly.left.paragraph.1' />
												</Paragraph>
											</Typography>
										</Card>
									</div>
								</>
							)}
							{product.name === 'donation.product.qurbani.title' && (
								<>
									<Card
										style={{ marginTop: '30px', width: '100%' }}
										className='gx-card'
									>
										<h2
											style={{
												paddingBottom: 0,
												textAlign: 'center',
												color: '#008E48'
											}}
										>
											<IntlMessages id={ayathId + '1'} />
										</h2>
									</Card>
									<Card
										style={{ marginTop: '30px', width: '100%' }}
										className='gx-card'
									>
										<h2
											style={{
												paddingBottom: 0,
												textAlign: 'center',
												color: '#008E48'
											}}
										>
											<IntlMessages id={ayathId + '2'} />
										</h2>
									</Card>
								</>
							)}
							{product.name === 'donation.product.complex.title' &&
								width > 768 ? (
								<Card
									style={{ marginTop: '30px', width: '100%' }}
									className='gx-card'
								>
									<h1 style={{ textAlign: 'center' }}>
										<IntlMessages id='donation.product.complex.info.title' />
									</h1>
									<p>
										<IntlMessages id='donation.product.complex.info.1' />
									</p>
									<p
										style={{ color: 'green', cursor: 'pointer' }}
										onClick={() => history.push('/membership')}
									>
										<IntlMessages id='donation.product.complex.info.2' />
									</p>
									<p>
										<IntlMessages id='donation.product.complex.info.3' />
									</p>
								</Card>
							) : null}
							{product.name === 'donation.product.zakat.title' &&
								width > 768 ? (
								<Card
									style={{ marginTop: '30px', width: '100%' }}
									className='gx-card'
								>
									<p style={{ color: 'green' }}>
										<IntlMessages id='zakat.top.left.header.1' />
									</p>
									<p>
										<IntlMessages id='zakat.top.left.paragraph.1' />
									</p>
									<p>
										<IntlMessages id='zakat.top.left.paragraph.2' />
									</p>
									<p style={{ color: 'green' }}>
										<IntlMessages id='zakat.top.left.paragraph.3' />
									</p>
									<Timeline style={{ paddingTop: 10 }}>
										{/* <Timeline.Item style={{ color: 'green', cursor: 'pointer' }}
										onClick={() => history.push('/link')}
								>
									<IntlMessages id='zakat.top.left.bullet.1' />
								</Timeline.Item> */}
										<Timeline.Item color='green'>
											<Link
												to='/self-reliance-project'
												style={{
													textDecoration: 'underline'
												}}
											>
												<IntlMessages id='zakat.top.left.bullet.1' />
											</Link>
										</Timeline.Item>
										<Timeline.Item color='green'>
											<Link
												to='/scholarships-for-training-unemployed-unskilled'
												style={{
													textDecoration: 'underline'
												}}
											>
												<IntlMessages id='zakat.top.left.bullet.2' />
											</Link>
										</Timeline.Item>
										<Timeline.Item color='green'>
											<IntlMessages id='zakat.top.left.bullet.3' />
										</Timeline.Item>
									</Timeline>
									{/* <p>
										<IntlMessages id='zakat.top.left.paragraph.4' />
									</p> */}
								</Card>
							) : null}

							{product.name === 'donation.product.tree-plantation.title' && (
								<div className='card-view-md'>
									<TreePlantation />
								</div>
							)}
						</div>
						<div className='flood-card-xs'>
							{product.name === 'donation.product.flood.title' && (
								<div>
									<Col xl={24}>
										<Card
											style={{ width: '100%', height: '90%' }}
											className='gx-card'
										>
											<Typography>
												<Paragraph>
													<IntlMessages id='flood.left.paragraph.1.1' />
												</Paragraph>
											</Typography>
											<Typography>
												<Paragraph>
													<IntlMessages id='flood.left.paragraph.1.2' />
												</Paragraph>
											</Typography>
											<Typography>
												<Paragraph>
													<IntlMessages id='flood.left.paragraph.1.3' />
												</Paragraph>
											</Typography>
										</Card>
									</Col>
									{/* <Col xl={24}>
										<Card
											style={{ width: '100%', height: '90%' }}
											className='gx-card'
										>
											<Typography>
												<Paragraph>
													<IntlMessages id='flood.right.paragraph.1' />
												</Paragraph>
												<Paragraph>
													<IntlMessages id='flood.right.paragraph.2' />
												</Paragraph>
											</Typography>
										</Card>
									</Col> */}
								</div>
							)}
						</div>
						<div className='emergency-card-xs'>
							{product.name === 'donation.product.emergency.title' && (
								<div>
									<Col xl={24}>
										<Card
											style={{ width: '100%', height: '90%' }}
											className='gx-card'
										>
											<Typography>
												<Paragraph>
													<IntlMessages id='donation.product.emergency.desc' />
												</Paragraph>
												<Paragraph>
													<IntlMessages
														id={'donation.product.emergency.top.right.1'}
													/>
												</Paragraph>
											</Typography>
										</Card>
									</Col>
									<Col xl={24}>
										<Card
											style={{ width: '100%', paddingTop: '30px' }}
											cover={<img alt='SSLCommerz Advertise' src={require('assets/images/sslcommerz-ad.png')} />}
											className='gx-card'
										>
										</Card>
									</Col>
									{/* <Col xl={24}>
										<Card
											style={{ width: '100%', height: '90%' }}
											className='gx-card'
										>
											<Typography>
												<Paragraph>
													<IntlMessages id='flood.right.paragraph.1' />
												</Paragraph>
												<Paragraph>
													<IntlMessages id='flood.right.paragraph.2' />
												</Paragraph>
											</Typography>
										</Card>
									</Col> */}
								</div>
							)}
						</div>
						<div className='qurbani-responsive-card-md'>
							{product.name === 'donation.product.qurbani.title' && <Qurbani />}
						</div>
					</Col>
					<Col
						xl={12}
						lg={12}
						md={24}
						sm={24}
						xs={24}
						style={{ marginTop: '20px' }}
					>
						<Card style={{ width: '100%', height: 'auto' }}>
							{!isZakatPaymentNextActive && (
								<>
									<h1>
										{product.name ? (
											<p>
												<IntlMessages id={product.name} />
											</p>
										) : null}
									</h1>
									{product.name === 'donation.product.monthly.title' ? (
										<div>
											<p style={{ paddingBottom: 10 }}>
												<IntlMessages id='donation.product.monthly.desc.main.title' />
											</p>

											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '-5px',
													paddingBottom: '15px'
												}}
											>
												{/* {[1, 2, 3, 4, 5].map((item, index) => (
													<p>
														<IntlMessages
															id={`donation.product.monthly.desc.message.${
																index + 1
															}`}
														/>
													</p>
												))} */}
												<Timeline className='custom-timeline'>
													{[1, 2, 3, 4, 5].map((item, index) => (
														<Timeline.Item color='green'>
															<IntlMessages
																id={`donation.product.monthly.desc.message.${index + 1
																	}`}
															/>
														</Timeline.Item>
													))}
												</Timeline>
											</div>
										</div>
									) : product.name === 'donation.product.emergency.title' ? (
										<div>
											<p style={{ paddingBottom: 10 }}>
												<IntlMessages id='donation.product.emergency.left.1' />
											</p>

											<div
												style={{
													display: 'flex',
													flexDirection: 'column',
													gap: '-5px'

													// paddingBottom: '15px'
												}}
											>
												{/* {[1, 2, 3, 4, 5].map((item, index) => (
											<p>
												<IntlMessages
													id={`donation.product.monthly.desc.message.${
														index + 1
													}`}
												/>
											</p>
										))} */}
												<Timeline className='custom-timeline'>
													{[2, 3, 4, 5].map((item, index) => (
														<Timeline.Item color='green'>
															<IntlMessages
																id={`donation.product.emergency.left.${item}`}
															/>
														</Timeline.Item>
													))}
												</Timeline>

												<Paragraph
													style={{
														paddingTop: '5px'
													}}
												>
													<IntlMessages id='donation.product.emergency.left.6' />
												</Paragraph>

												<h4 style={{ paddingTop: 5 }}>
													<IntlMessages
														id={
															'donation.product.complex.bank.bkash.nogod.rocket'
														}
													/>
													01958-277609
													<span style={{ paddingLeft: 5 }}>
														<IntlMessages
															id={
																'donation.product.bkash.nogod.rocket.send.payment.option'
															}
														/>
													</span>
												</h4>
											</div>
										</div>
									) : (
										<p style={{ paddingBottom: 10 }}>
											{product.description ? (
												<IntlMessages id={product.description} />
											) : null}
										</p>
									)}
								</>
							)}
							{/* {product.name === 'donation.product.qurbani.title' ? (
								<div>

									<div style={{ marginBottom: '23px' }}>
										<h4 style={{ margin: 0 }}>
											<IntlMessages
												id={'donation.product.complex.bank.bkash.nogod.rocket'}
											/>
											01958-277609
										</h4>
										<small style={{ fontSize: '14px' }}>
											<a
												href='https://forms.gle/4a2JFg55Limzj1nv5'
												target='_blank'
												style={{
													fontSize: '14px'
												}}
												rel='noopener noreferrer'
											>
												<IntlMessages
													id={'donation.product.qurbani.google.form.desc'}
												/>
											</a>
										</small>
									</div>
									<h4 style={{ paddingBottom: 10 }}>
										<IntlMessages
											id={'donation.product.qurbani.bank.info.title'}
										/>
									</h4>donation.product.qurbani.title.expire
								</div>
							) : null}
							{product.name === 'donation.product.qurbani.title' && (
								<Col>
									<QurbaniBankAccount1 />
								</Col>
							)} */}
							{product.name === 'donation.product.qurbani.title' && (
								<Col>
									<h3
										style={{ paddingBottom: 21, paddingTop: 21, color: 'red' }}
									>
										<IntlMessages
											id={'donation.product.qurbani.title.expire'}
										/>
									</h3>
								</Col>
							)}
							{product.name === 'donation.product.zakat.title' ? (
								<>
									{!isZakatPaymentNextActive && (
										<Button
											type='primary'
											style={{ float: 'center', marginBottom: '20px' }}
											onClick={() => {
												history.push('/zakat-calculator')
											}}
										>
											<IntlMessages id='nav.zakat.goto.button' />
										</Button>
									)}
									<div style={{ marginBottom: '23px' }}>
										<h4 style={{ margin: 0 }}>
											<IntlMessages
												id={'donation.product.zakat.bank.bkash.nogod.rocket'}
											/>
											01958-277607
										</h4>
										<small style={{ fontSize: '14px' }}>
											(
											<IntlMessages
												id={'donation.product.zakat.bank.bkash.nogod.charge'}
											/>
											)
										</small>
									</div>
									{/* <br /> */}
									{!isZakatPaymentNextActive ? (
										<h4 style={{ paddingBottom: 10 }}>
											<IntlMessages
												id={'donation.product.zakat.bank.info.title'}
											/>
										</h4>
									) : (
										<h4 style={{ paddingBottom: 10, textAlign: 'center' }}>
											<IntlMessages
												id={'donation.product.zakat.bank.info.title.2'}
											/>
										</h4>
									)}
									{/* <Card bodyStyle={{ padding: 0 }}
									style={{ paddingLeft: 15, paddingRight: 10, paddingTop: 10, paddingBottom: 10 }}
									> */}
									<Col>
										<ZakatBankAccount2 />
										<ZakatBankAccount1 />
									</Col>
									{isZakatPaymentNextActive && (
										<ZakatPaymentMethod
											paymentInfo={paymentInfo}
											submitFunction={onSubmit}
										/>
									)}
								</>
							) : null}
							{product.name === 'donation.product.emergency.title' ? (
								<>
									<p>
										{/* <IntlMessages
											id={'donation.product.emergency.top.right.1'}
										/>
										<br /> */}
										{/* <IntlMessages
											id={'donation.product.tree-plantation.tree2.title'}
										/>
										<br />
										<IntlMessages
											id={'donation.product.tree-plantation.tree3.title'}
										/>
										<br /> */}
										{/* <IntlMessages
											id={'donation.product.tree-plantation.tree4.title'}
										/> */}
									</p>
									<h4 style={{ paddingBottom: 15 }}>
										<IntlMessages id={'donation.product.bank.info.title'} />
									</h4>
									<EmergencyBankAccount1 />
								</>
							) : null}

							{/* {product.name === 'donation.product.qurbani.title' ? (
								<>
									<h3>
										<IntlMessages
											id={'donation.product.qurbani.bank.info.title'}
										/>
									</h3>
									<p style={{ paddingBottom: 10 }}>
										<IntlMessages
											id={'donation.product.zakat.bank.account.name'}
										/>{' '}
										As Sunnah Foundation
										<br />
										<IntlMessages
											id={'donation.product.zakat.bank.account.no'}
										/>{' '}
										07511100103013
										<br />
										<IntlMessages
											id={'donation.product.zakat.bank.name'}
										/>{' '}
										EXIM Bank Limited
										<br />
										<IntlMessages
											id={'donation.product.zakat.bank.branch.name'}
										/>{' '}
										Satarkul Branch
										<br />
										<IntlMessages
											id={'donation.product.complex.bank.swift.code'}
										/>{' '}
										EXBKBDDH
										<br />
										<IntlMessages
											id={'donation.product.complex.bank.routing.no'}
										/>{' '}
										100264025
										<br />
										<br />
										<IntlMessages
											id={'donation.product.complex.bank.bkash.nogod.rocket'}
										/>
										01958-277609
										<br />
										<span
											style={{
												fontSize: '15px'
											}}
										>
											(পেমেন্ট করতে হবে)
										</span>
										<br />
										<IntlMessages
											id={'donation.product.complex.bank.nogod.rocket'}
										/>
										01408506070
										<br />
									</p>
									<p></p>
								</>
							) : null} */}
							{product.name === 'donation.product.self-reliant.title' ? (
								<>
									<h3
										style={{
											color: 'red'
										}}
									>
										<IntlMessages id={'donation.product.self-reliant.NB'} />
									</h3>
									<a href='https://assunnahfoundation.org/donate/zakat'>
										<IntlMessages
											id={'donation.product.self-reliant.link-info'}
										/>
									</a>
									<div style={{ paddingBottom: '10px' }}></div>
								</>
							) : null}
							{product.name === 'donation.product.complex.title' ? (
								<>
									<a
										href='#complex'
										style={{ color: 'green', textDecoration: 'underline' }}
									>
										<IntlMessages id={'complex.left.paragraph.1'} />
									</a>
									<h4 style={{ marginTop: 10 }}>
										<IntlMessages
											id={'donation.product.complex.bank.info.title'}
										/>
									</h4>
									<div style={{ paddingBottom: 0, paddingTop: 10 }}>
										<ComplexBankAccount1 />
									</div>
									{/* <p style={{ paddingBottom: 10, paddingTop: 10 }}>
										<IntlMessages
											id={'donation.product.zakat.bank.account.name'}
										/>{' '}
										As sunnah Foundation
										<br />
										<IntlMessages
											id={'donation.product.zakat.bank.account.no'}
										/>{' '}
										20503100201496517
										<br />
										<IntlMessages
											id={'donation.product.zakat.bank.name'}
										/>{' '}
										Islami Bank Bangladesh ltd
										<br />
										<IntlMessages
											id={'donation.product.zakat.bank.branch.name'}
										/>{' '}
										Badda, Dhaka.
										<br />
										<IntlMessages
											id={'donation.product.complex.bank.routing.no'}
										/>{' '}
										125260341
										<br />
										<IntlMessages
											id={'donation.product.complex.bank.swift.code'}
										/>{' '}
										IBBLBDDH
										<br />
									</p> */}
									<p>
										<IntlMessages
											id={'donation.product.complex.bank.bkash.nogod.rocket'}
										/>
										01958277608
										<br />
									</p>
									<h4
										style={{
											fontWeight: 'bolder'
										}}
									>
										<IntlMessages
											id={'donation.product.complex.per.sqare.feet.price'}
										/>
									</h4>
								</>
							) : null}
							{product.name === 'donation.product.flood.title' ? (
								<>
									{/* <h4 style={{ paddingBottom: 5 }}>
										<IntlMessages
											id={'donation.product.complex.bank.bkash.nogod.rocket'}
										/>
										01958-277609
										<span style={{ paddingLeft: 5 }}>
											<IntlMessages
												id={
													'donation.product.bkash.nogod.rocket.send.payment.option'
												}
											/>
										</span>
									</h4>
									<h4 style={{ paddingBottom: 15 }}>
										<IntlMessages id={'donation.product.bank.info.title'} />
									</h4>
									<FloodBankAccount2 />
									<FloodBankAccount1 />
									<br /> */}
								</>
							) : null}
							{product.name === 'donation.product.iftar.title' ? (
								<RadioGroup
									buttonStyle='solid'
									size='large'
									style={{
										flexDirection: 'column',
										width: '100%'
									}}
								>
									<Row>
										<Col xl={8} xs={12}>
											<RadioButton
												value='1500'
												onChange={() => {
													selectedAmount('1500')
												}}
												style={{
													width: '100%',
													height: 60,
													paddingTop: 5,
													paddingLeft: 15
												}}
											>
												1500 ৳
											</RadioButton>
										</Col>
										<Col xl={8} xs={12}>
											<RadioButton
												value='3000'
												onChange={() => {
													selectedAmount('3000')
												}}
												style={{
													width: '100%',
													height: 60,
													paddingTop: 5,
													paddingLeft: 15
												}}
											>
												3000 ৳
											</RadioButton>
										</Col>
										<Col xl={8} xs={12}>
											<RadioButton
												value='4500'
												onChange={() => {
													selectedAmount('4500')
												}}
												style={{
													width: '100%',
													height: 60,
													paddingTop: 5,
													paddingLeft: 15
												}}
											>
												4500 ৳
											</RadioButton>
										</Col>
										<Col xl={8} xs={12}>
											<RadioButton
												value='6000'
												onChange={() => {
													selectedAmount('6000')
												}}
												style={{
													width: '100%',
													height: 60,
													paddingTop: 5,
													paddingLeft: 15
												}}
											>
												6000 ৳
											</RadioButton>
										</Col>
										<Col xl={8} xs={12}>
											<RadioButton
												value='7500'
												onChange={() => {
													selectedAmount('7500')
												}}
												style={{
													width: '100%',
													height: 60,
													paddingTop: 5,
													paddingLeft: 15
												}}
											>
												7500 ৳
											</RadioButton>
										</Col>
										<Col xl={8} xs={12}>
											<RadioButton
												value='0'
												onChange={() => {
													selectedAmount('0')
												}}
												style={{
													width: '100%',
													height: 60,
													paddingTop: 5,
													paddingLeft: 15
												}}
											>
												Other
											</RadioButton>
										</Col>
									</Row>
								</RadioGroup>
							) : product.name === 'donation.product.qurbani.title' ? (
								<>
									{isNextButtonActive && cowIncrement < 1 ? null : (
										<Row style={width < 768 ? styles.productRow : {}}>
											<Col xl={7} lg={5} md={8} sm={14} xs={14}>
												<h4
													style={{
														paddingTop: 8,
														color: '#008E48',
														float: 'left'
													}}
												>
													<IntlMessages id='donation.product.qurbani.cow' />
												</h4>
											</Col>
											<Col xl={5} lg={4} md={6} sm={10} xs={10}>
												<h4 style={{ paddingTop: 8, float: 'left' }}>
													{cowPrice} ৳
												</h4>
											</Col>
											<Col xl={8} lg={9} md={6} sm={14} xs={14}>
												<Row style={{ paddingLeft: 10 }}>
													{!isNextButtonActive ? (
														<Button
															onClick={() => {
																setCowIncrement(
																	cowIncrement > 0
																		? --cowIncrement
																		: cowIncrement
																)
																setCowQurbaniNameList(prevList => {
																	if (prevList.length === 0) {
																		return prevList
																	}
																	const newList = prevList.slice(0, -1)
																	return newList
																})
																// if(cowQurbaniNameList.length)
																selectedIncrementAmount()
																if (cowIncrement < 1) {
																	setCowQurbaniNameList([])
																}
															}}
														>
															<h4
																style={{
																	paddingTop: 8,
																	fontWeight: 'bold',
																	color: '#F5222D'
																}}
															>
																-
															</h4>
														</Button>
													) : null}
													<h4
														style={{
															paddingTop: 8,
															paddingRight: 15,
															width: '40px',
															textAlign: 'center'
														}}
													>
														{cowIncrement}
													</h4>
													{!isNextButtonActive ? (
														<Button
															onClick={() => {
																setCowIncrement(++cowIncrement)
																selectedIncrementAmount()
															}}
														>
															<h4
																style={{
																	paddingTop: 8,
																	fontWeight: 'bold',
																	color: '#008E48'
																}}
															>
																+
															</h4>
														</Button>
													) : null}
												</Row>
											</Col>
											<Col xl={4} lg={6} md={4} sm={10} xs={10}>
												<h4 style={{ paddingTop: 8, float: 'left' }}>
													{cowPrice * cowIncrement} ৳
												</h4>
											</Col>
										</Row>
									)}
									<Row>
										{cowIncrement > 0 ? (
											<>
												<Col xl={24} lg={24} md={24} sm={24} xs={24}>
													<p>
														{' '}
														আপনি {cowIncrement} টি গরু কুরবানির জন্য নিয়্যত করায়
														সর্বোচ্চ {cowIncrement * 7} টি নাম অন্তর্ভুক্ত করতে
														পারবেন।
													</p>
												</Col>
											</>
										) : null}
										{isCowQurbaniNamesFormOpen && isNextButtonActive ? (
											<Col xl={24} lg={24} md={24} sm={24} xs={24}>
												<p style={{ paddingLeft: 10 }}>
													{' '}
													যার পক্ষ থেকে গরু কুরবানি দেয়া হচ্ছে তাঁর -{' '}
												</p>
												<Form
													{...formItemLayout}
													form={cowQurbaniNamesForm}
													name='cowQurbaniNamesForm'
													onFinish={onSubmitCowQurbaniNames}
													style={{ margineTop: 10 }}
												//scrollToFirstError
												>
													<Form.Item
														name='donorName'
														label={intl.formatMessage({
															id: 'payment.info.donorName'
														})}
														rules={[
															{
																required: true,
																min: 3,
																max: 100,
																message: intl.formatMessage({
																	id: 'payment.info.donorName.errorMessage'
																}),
																whitespace: true
															}
														]}
													>
														<Input />
													</Form.Item>
													<Form.Item
														name='fathersName'
														label={intl.formatMessage({
															id: 'payment.info.donor.fathersName'
														})}
														rules={[
															{
																required: true,
																min: 3,
																max: 100,
																message: intl.formatMessage({
																	id: 'payment.info.donorName.errorMessage'
																}),
																whitespace: true
															}
														]}
													>
														<Input />
													</Form.Item>
													<Button
														type='primary'
														htmlType='submit'
														style={{ float: 'right', marginBottom: '20px' }}
													//block
													>
														<IntlMessages id='nav.volunteer.formSendButton' />
													</Button>
												</Form>
											</Col>
										) : null}
										{cowQurbaniNameList.length > 0 && isNextButtonActive ? (
											<>
												<Row>
													<Col xl={24} lg={24} md={24} sm={24} xs={24}>
														<Table
															//className="virtual-table"
															columns={cowQurbaniNamesColumns}
															dataSource={cowQurbaniNameList.map(item => item)}
															pagination={false}
															style={{ marginBottom: 20, width: '100%' }}
															scroll={{ x: 110 }}
														// onRow={record => ({
														// 	onClick: () => handleRowClick(record)
														// })}
														//scroll={{ x: width < 320 ? 130 : width < 375 ? 140 : width < 425 ? 160 : width < 768 ? 260 : width < 1024 ? 200 : 280 }}
														/>
													</Col>
												</Row>
												{cowQurbaniNameList.length < cowIncrement * 7 &&
													!isCowQurbaniNamesFormOpen ? (
													<Col xl={24} lg={24} md={24} sm={24} xs={24}>
														<Button
															type='primary'
															style={{ float: 'right', marginBottom: '25px' }}
															onClick={() => {
																setIsCowQurbaniNamesFormOpen(true)
															}}
														>
															<IntlMessages id='nav.volunteer.add.more.button' />
														</Button>
													</Col>
												) : null}
											</>
										) : null}
									</Row>
									{isNextButtonActive && sharedCowIncrement < 1 ? null : (
										<Row style={width < 768 ? styles.productRow : {}}>
											<Col xl={7} lg={5} md={8} sm={14} xs={14}>
												<h4
													style={{
														paddingTop: 8,
														color: '#008E48',
														float: 'left'
													}}
												>
													<IntlMessages id='donation.product.qurbani.sharedCow' />
												</h4>
											</Col>
											<Col xl={5} lg={4} md={6} sm={10} xs={10}>
												<h4 style={{ paddingTop: 8 }}>{sharedCowPrice} ৳</h4>
											</Col>
											<Col xl={8} lg={9} md={6} sm={14} xs={14}>
												<Row style={{ paddingLeft: 10 }}>
													{!isNextButtonActive ? (
														<Button
															onClick={() => {
																setSharedCowIncrement(
																	sharedCowIncrement > 0
																		? --sharedCowIncrement
																		: sharedCowIncrement
																)
																setSharedCowQurbaniNameList(prevList => {
																	if (prevList.length === 0) {
																		return prevList
																	}
																	const newList = prevList.slice(0, -1)
																	return newList
																})
																selectedIncrementAmount()
																if (sharedCowIncrement < 1) {
																	setSharedCowQurbaniNameList([])
																}
															}}
														>
															<h4
																style={{
																	paddingTop: 8,
																	fontWeight: 'bold',
																	color: '#F5222D'
																}}
															>
																-
															</h4>
														</Button>
													) : null}
													<h4
														style={{
															paddingTop: 8,
															paddingRight: 15,
															width: '40px',
															textAlign: 'center'
														}}
													>
														{sharedCowIncrement}
													</h4>
													{!isNextButtonActive ? (
														<Button
															onClick={() => {
																setSharedCowIncrement(++sharedCowIncrement)
																selectedIncrementAmount()
															}}
														>
															<h4
																style={{
																	paddingTop: 8,
																	fontWeight: 'bold',
																	color: '#008E48'
																}}
															>
																+
															</h4>
														</Button>
													) : null}
												</Row>
											</Col>
											<Col xl={4} lg={6} md={4} sm={10} xs={10}>
												<h4 style={{ paddingTop: 8, float: 'left' }}>
													{sharedCowIncrement * sharedCowPrice} ৳
												</h4>
											</Col>
										</Row>
									)}
									<Row>
										{sharedCowIncrement > 0 ? (
											<>
												<Col xl={24} lg={24} md={24} sm={24} xs={24}>
													<p>
														{' '}
														আপনি {sharedCowIncrement} টি গরুর ভাগ কুরবানির জন্য
														নিয়্যত করায় সর্বোচ্চ {sharedCowIncrement} টি নাম
														অন্তর্ভুক্ত করতে পারবেন।{' '}
													</p>
												</Col>
											</>
										) : null}
										{isSharedCowQurbaniNamesFormOpen && isNextButtonActive ? (
											<Col xl={24} lg={24} md={24} sm={24} xs={24}>
												<p style={{ paddingLeft: 10 }}>
													{' '}
													যার পক্ষ থেকে গরুর ভাগ কুরবানি দেয়া হচ্ছে তাঁর -{' '}
												</p>
												<Form
													{...formItemLayout}
													form={sharedCowQurbaniNamesForm}
													name='sharedCowQurbaniNamesForm'
													onFinish={onSubmitSharedCowQurbaniNames}
													style={{ margineTop: 10 }}
												//scrollToFirstError
												>
													<Form.Item
														name='donorName'
														label={intl.formatMessage({
															id: 'payment.info.donorName'
														})}
														// rules={[
														// 	{
														// 		required: true,
														// 		min: 7,
														// 		max: 100,
														// 		message: intl.formatMessage({
														// 			id: 'payment.info.donorName.errorMessage'
														// 		}),
														// 		whitespace: true
														// 	}
														// ]}
														rules={[
															{
																required: true,
																min: 3,
																max: 100,
																message: intl.formatMessage({
																	id: 'payment.info.donorName.errorMessage'
																}),
																whitespace: true
															}
														]}
													>
														<Input />
													</Form.Item>
													<Form.Item
														name='fathersName'
														label={intl.formatMessage({
															id: 'payment.info.donor.fathersName'
														})}
														rules={[
															{
																required: true,
																min: 3,
																max: 100,
																message: intl.formatMessage({
																	id: 'payment.info.donorName.errorMessage'
																}),
																whitespace: true
															}
														]}
													>
														<Input />
													</Form.Item>
													<Button
														type='primary'
														htmlType='submit'
														style={{ float: 'right', marginBottom: '20px' }}
													//block
													>
														<IntlMessages id='nav.volunteer.formSendButton' />
													</Button>
												</Form>
											</Col>
										) : null}
										{sharedCowQurbaniNameList.length > 0 &&
											isNextButtonActive ? (
											<>
												<Row>
													<Col xl={24} lg={24} md={24} sm={24} xs={24}>
														<Table
															//className="virtual-table"
															columns={sharedCowQurbaniNamesColumns}
															dataSource={sharedCowQurbaniNameList.map(
																item => item
															)}
															pagination={false}
															style={{ marginBottom: 20 }}
															scroll={{ x: 110 }}
														/>
													</Col>
												</Row>
												{sharedCowQurbaniNameList.length < sharedCowIncrement &&
													!isSharedCowQurbaniNamesFormOpen ? (
													<Col xl={24} lg={24} md={24} sm={24} xs={24}>
														<Button
															type='primary'
															style={{ float: 'right', marginBottom: '25px' }}
															onClick={() => {
																setIsSharedCowQurbaniNamesFormOpen(true)
															}}
														>
															<IntlMessages id='nav.volunteer.add.more.button' />
														</Button>
													</Col>
												) : null}
											</>
										) : null}
									</Row>
									{isNextButtonActive && goatIncrement < 1 ? null : (
										<Row style={width < 768 ? styles.productRow : {}}>
											<Col xl={7} lg={5} md={8} sm={14} xs={14}>
												<h4
													style={{
														paddingTop: 8,
														color: '#008E48',
														float: 'left'
													}}
												>
													<IntlMessages id='donation.product.qurbani.goat' />
												</h4>
											</Col>
											<Col xl={5} lg={4} md={6} sm={10} xs={10}>
												<h4 style={{ paddingTop: 8 }}>{chagolPrice} ৳</h4>
											</Col>
											<Col xl={8} lg={9} md={6} sm={14} xs={14}>
												<Row style={{ paddingLeft: 10 }}>
													{!isNextButtonActive ? (
														<Button
															style={{ float: 'right' }}
															onClick={() => {
																setGoatIncrement(
																	goatIncrement > 0
																		? --goatIncrement
																		: goatIncrement
																)
																setGoatQurbaniNameList(prevList => {
																	if (prevList.length === 0) {
																		return prevList
																	}
																	const newList = prevList.slice(0, -1)
																	return newList
																})
																selectedIncrementAmount()
																if (goatIncrement < 1) {
																	setGoatQurbaniNameList([])
																}
															}}
														>
															<h4
																style={{
																	paddingTop: 8,
																	fontWeight: 'bold',
																	color: '#F5222D'
																}}
															>
																-
															</h4>
														</Button>
													) : null}
													<h4
														style={{
															paddingTop: 8,
															paddingRight: 15,
															width: '40px',
															textAlign: 'center'
														}}
													>
														{goatIncrement}
													</h4>
													{!isNextButtonActive ? (
														<Button
															style={{ float: 'right' }}
															onClick={() => {
																setGoatIncrement(++goatIncrement)
																selectedIncrementAmount()
															}}
														>
															<h4
																style={{
																	paddingTop: 8,
																	fontWeight: 'bold',
																	color: '#008E48'
																}}
															>
																+
															</h4>
														</Button>
													) : null}
												</Row>
											</Col>
											<Col xl={4} lg={6} md={4} sm={10} xs={10}>
												<h4 style={{ paddingTop: 8, float: 'left' }}>
													{goatIncrement * chagolPrice} ৳
												</h4>
											</Col>
										</Row>
									)}
									<Row>
										{goatIncrement > 0 ? (
											<>
												<Col xl={24} lg={24} md={24} sm={24} xs={24}>
													<p>
														{' '}
														আপনি {goatIncrement} টি ছাগল কুরবানির জন্য নিয়্যত
														করায় সর্বোচ্চ {goatIncrement} টি নাম অন্তর্ভুক্ত
														করতে পারবেন।{' '}
													</p>
												</Col>
											</>
										) : null}
										{isGoatQurbaniNamesFormOpen && isNextButtonActive ? (
											<Col xl={24} lg={24} md={24} sm={24} xs={24}>
												<p style={{ paddingLeft: 10 }}>
													{' '}
													যার পক্ষ থেকে ছাগল কুরবানি দেয়া হচ্ছে তাঁর -{' '}
												</p>
												<Form
													{...formItemLayout}
													form={goatQurbaniNamesForm}
													name='goatQurbaniNamesForm'
													onFinish={onSubmitGoatQurbaniNames}
													style={{ margineTop: 10 }}
												//scrollToFirstError
												>
													<Form.Item
														name='donorName'
														label={intl.formatMessage({
															id: 'payment.info.donorName'
														})}
														rules={[
															{
																required: true,
																min: 3,
																max: 100,
																message: intl.formatMessage({
																	id: 'payment.info.donorName.errorMessage'
																}),
																whitespace: true
															}
														]}
													>
														<Input />
													</Form.Item>
													<Form.Item
														name='fathersName'
														label={intl.formatMessage({
															id: 'payment.info.donor.fathersName'
														})}
														rules={[
															{
																required: true,
																min: 3,
																max: 100,
																message: intl.formatMessage({
																	id: 'payment.info.donorName.errorMessage'
																}),
																whitespace: true
															}
														]}
													>
														<Input />
													</Form.Item>
													<Button
														type='primary'
														htmlType='submit'
														style={{ float: 'right' }}
													>
														<IntlMessages id='nav.volunteer.formSendButton' />
													</Button>
												</Form>
											</Col>
										) : null}
										{goatQurbaniNameList.length > 0 && isNextButtonActive ? (
											<>
												<Row>
													<Col xl={24} lg={24} md={24} sm={24} xs={24}>
														<Table
															// className='virtual-table'
															className='full-width-table'
															columns={goatQurbaniNamesColumns}
															dataSource={goatQurbaniNameList.map(item => item)}
															pagination={false}
															style={{ marginBottom: 20 }}
															scroll={{ x: 110 }}
														/>
													</Col>
												</Row>
												{goatQurbaniNameList.length < goatIncrement &&
													!isGoatQurbaniNamesFormOpen ? (
													<Col xl={24} lg={24} md={24} sm={24} xs={24}>
														<Button
															type='primary'
															style={{ float: 'right', marginBottom: '25px' }}
															onClick={() => {
																setIsGoatQurbaniNamesFormOpen(true)
															}}
														>
															<IntlMessages id='nav.volunteer.add.more.button' />
														</Button>
													</Col>
												) : null}
											</>
										) : null}
									</Row>
								</>
							) : product.name === 'donation.product.complex.title' ? (
								<>
									<RadioGroup
										buttonStyle='solid'
										size='large'
										style={{
											flexDirection: 'column',
											width: '100%'
										}}
									>
										<Row>
											<Col xl={8} xs={12}>
												<RadioButton
													value='4000'
													onChange={() => {
														selectedAmount('4000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													4000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='8000'
													onChange={() => {
														selectedAmount('8000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													8000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='12000'
													onChange={() => {
														selectedAmount('12000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													12000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='16000'
													onChange={() => {
														selectedAmount('16000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													16000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='20000'
													onChange={() => {
														selectedAmount('20000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													20000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='24000'
													onChange={() => {
														selectedAmount('24000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													24000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='28000'
													onChange={() => {
														selectedAmount('28000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													28000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='32000'
													onChange={() => {
														selectedAmount('32000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													32000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='0'
													onChange={() => {
														selectedAmount('0')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													Other
												</RadioButton>
											</Col>
										</Row>
									</RadioGroup>
								</>
							) : product.name === 'donation.product.monthly.title' ? (
								<>
									<MonthlyTab
										RadioGroup={RadioGroup}
										RadioButton={RadioButton}
										selectedAmount={selectedAmount}
										selectedSubscription={selectedSubscription}
										setSelectedSubscription={setSelectedSubscription}
										handleDonationTabChange={handleDonationTabChange}
										selectedMonthlyGateway={selectedMonthlyGateway}
									/>
									{/* <RadioGroup
										buttonStyle='solid'
										size='large'
										style={{
											flexDirection: 'column',
											width: '100%'
										}}
									>
										<Row>
											<Col xl={8} xs={12}>
												<RadioButton
													value='300'
													onChange={() => {
														selectedAmount('300')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													300 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='500'
													onChange={() => {
														selectedAmount('500')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													500 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='1000'
													onChange={() => {
														selectedAmount('1000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													1000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='2000'
													onChange={() => {
														selectedAmount('2000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													2000
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='5000'
													onChange={() => {
														selectedAmount('5000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													5000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='10000'
													onChange={() => {
														selectedAmount('10000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													10000 ৳
												</RadioButton>
											</Col>
										</Row>
									</RadioGroup> */}
								</>
							) : product.name === 'donation.product.winter.title' ? (
								<>
									<RadioGroup
										buttonStyle='solid'
										size='large'
										style={{
											flexDirection: 'column',
											width: '100%'
										}}
									>
										<Row>
											<Col xl={8} xs={12}>
												<RadioButton
													value='600'
													onChange={() => {
														selectedAmount('600')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													600 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='1200'
													onChange={() => {
														selectedAmount('1200')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													1200 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='1800'
													onChange={() => {
														selectedAmount('1800')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													1800 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='2400'
													onChange={() => {
														selectedAmount('2400')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													2400
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='3000'
													onChange={() => {
														selectedAmount('3000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													3000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='0'
													onChange={() => {
														selectedAmount('0')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													Other
												</RadioButton>
											</Col>
										</Row>
									</RadioGroup>
								</>
							) : product.name === 'donation.product.tree-plantation.title' ? (
								<>
									<RadioGroup
										buttonStyle='solid'
										size='large'
										style={{
											flexDirection: 'column',
											width: '100%'
										}}
									>
										<Row>
											<Col xl={8} xs={12}>
												<RadioButton
													value='700'
													onChange={() => {
														selectedAmount('700')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													700 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='1400'
													onChange={() => {
														selectedAmount('1400')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													1400 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='2100'
													onChange={() => {
														selectedAmount('2100')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													2100 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='2800'
													onChange={() => {
														selectedAmount('2800')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													2800
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='3500'
													onChange={() => {
														selectedAmount('3500')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													3500 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='0'
													onChange={() => {
														selectedAmount('0')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													Other
												</RadioButton>
											</Col>
										</Row>
									</RadioGroup>
								</>
							) : product.name === 'donation.product.flood.title' ? (
								<>
									<RadioGroup
										buttonStyle='solid'
										size='large'
										style={{
											flexDirection: 'column',
											width: '100%'
										}}
									>
										<Row>
											<Col xl={8} xs={12}>
												<RadioButton
													value='100'
													onChange={() => {
														selectedAmount('100')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													100 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='500'
													onChange={() => {
														selectedAmount('500')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													500 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='1000'
													onChange={() => {
														selectedAmount('1000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													1000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='5000'
													onChange={() => {
														selectedAmount('5000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													5000
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='10000'
													onChange={() => {
														selectedAmount('10000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													10000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='0'
													onChange={() => {
														selectedAmount('0')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													Other
												</RadioButton>
											</Col>
										</Row>
									</RadioGroup>
								</>
							) : (
								!isZakatPaymentNextActive && (
									<RadioGroup
										buttonStyle='solid'
										size='large'
										style={{
											flexDirection: 'column',
											width: '100%'
										}}
									>
										<Row>
											<Col xl={8} xs={12}>
												<RadioButton
													value='100'
													onChange={() => {
														selectedAmount('100')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													100 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='1000'
													onChange={() => {
														selectedAmount('1000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													1000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='5000'
													onChange={() => {
														selectedAmount('5000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													5000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='10000'
													onChange={() => {
														selectedAmount('10000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													10000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='50000'
													onChange={() => {
														selectedAmount('50000')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													50000 ৳
												</RadioButton>
											</Col>
											<Col xl={8} xs={12}>
												<RadioButton
													value='0'
													onChange={() => {
														selectedAmount('0')
													}}
													style={{
														width: '100%',
														height: 60,
														paddingTop: 5,
														paddingLeft: 15
													}}
												>
													Other
												</RadioButton>
											</Col>
										</Row>
									</RadioGroup>
								)
							)}
							{product.name === 'donation.product.complex.title' ? (
								<>
									<div style={{ paddingBottom: 10 }}></div>
									<p style={{ color: '#008E48' }}>{donationMessage}</p>
								</>
							) : null}
							{product.name === 'donation.product.tree-plantation.title' &&
								amount &&
								amount !== '0' ? (
								<>
									<div style={{ paddingBottom: 10 }}></div>
									<p style={{ color: '#008E48' }}>
										<IntlMessages
											id={`donation.product.tree-plantation.tree1.suggetion.${amount}`}
										/>
									</p>
								</>
							) : null}
							{!isZakatPaymentNextActive && (
								<div>
									<Checkbox
										onChange={onSuggestionCheckBoxChange}
										checked={checked}
										style={{
											display:
												product.name === 'donation.product.qurbani.title'
													? 'none'
													: 'flex'
										}}
									>
										<IntlMessages id='payment.info.amount.suggestion.6' />
									</Checkbox>
								</div>
							)}
							<div style={{ paddingBottom: 10 }}></div>
							{!isZakatPaymentNextActive && (
								<Form
									{...formItemLayout}
									onChange={() => {
										setAmountFieldError(false)
										setPhoneFieldError(false)
									}}
									form={form}
									name='form'
									onFinish={onSubmit}
									style={{
										margineTop: 10
									}}
								//scrollToFirstError
								>
									{product.name === 'donation.product.monthly.title' ? (
										<Form.Item
											name='amount'
											initialValue={initialDonationAmount}
											label={intl.formatMessage({ id: 'payment.info.amount' })}
											validateStatus={amountFieldError ? 'error' : ''}
											help={
												amountFieldError
													? intl.formatMessage({
														id:
															selectedMonthlyGateway === 'bkash_recurring'
																? 'payment.info.amount.errorMessage.1'
																: 'payment.info.amount.errorMessage.10'
													})
													: undefined
											}
											rules={[
												{
													required: true,
													message: intl.formatMessage({
														id:
															selectedMonthlyGateway === 'bkash_recurring'
																? 'payment.info.amount.errorMessage.1'
																: 'payment.info.amount.errorMessage.10'
													})
												}
											]}
										>
											<InputNumber
												type='number'
												min={
													selectedMonthlyGateway === 'bkash_recurring' ? 1 : 10
												}
												max={9999999999999}
												disabled={disableAmountField}
												style={{
													width: '100%',
													...(amountFieldError && { border: '1px solid red' })
												}}
											/>
										</Form.Item>
									) : (
										<Form.Item
											name='amount'
											initialValue={10}
											label={intl.formatMessage({ id: 'payment.info.amount' })}
											validateStatus={amountFieldError ? 'error' : ''}
											help={
												amountFieldError
													? intl.formatMessage({
														id: 'payment.info.amount.errorMessage'
													})
													: undefined
											}
											rules={[
												{
													required: true,
													message: intl.formatMessage({
														id: 'payment.info.amount.errorMessage'
													})
												}
											]}
										>
											<InputNumber
												type='number'
												min={10}
												max={9999999999999}
												disabled={disableAmountField}
												style={{
													width: '100%',
													...(amountFieldError && { border: '1px solid red' })
												}}
											/>
										</Form.Item>
									)}

									{/* {product.productType === 'donation.product.regular' || product.name === 'donation.product.qurbani.title' ? null : (
									<div style={{ marginBottom: 20 }}>
										<Checkbox onChange={onCheckBoxChange}>
											<IntlMessages id='payment.info.anonymous' />
										</Checkbox>
									</div>
								)} */}

									{/* {product.name === 'donation.product.monthly.title' ? (
										<Form.Item
											name='subscription'
											label={intl.formatMessage({
												id: 'payment.info.subscription'
											})}
											rules={[
												{
													required: true,
													message: intl.formatMessage({
														id: 'payment.info.subscriptionMessage'
													}),
													whitespace: true
												}
											]}
										>
											<Select
												defaultValue={'DAILY'}
												options={subscriptionFrequencies}
											/>
										</Form.Item>
									) : null} */}

									<Form.Item
										name='donorName'
										label={intl.formatMessage({ id: 'payment.info.donorName' })}
										rules={[
											{
												required: false,
												min: 3,
												max: 100,
												message: intl.formatMessage({
													id: 'payment.info.donorName.errorMessage'
												}),
												whitespace: true
											}
										]}
									>
										<Input />
									</Form.Item>
									<Form.Item
										name='phoneOrEmail'
										label={intl.formatMessage({
											id: 'payment.info.emailORphone'
										})}
										validateStatus={phoneFieldError ? 'error' : ''}
										help={
											phoneFieldError
												? intl.formatMessage({
													id: 'payment.info.emailOrPhoneErrorMessage'
												})
												: undefined
										}
										rules={[
											{
												required: true,
												pattern: phoneOrEmailRegex,
												message: intl.formatMessage({
													id: 'payment.info.emailOrPhoneErrorMessage'
												}),
												whitespace: true
											}
										]}
									>
										<Input
											style={{
												...(phoneFieldError && { border: '1px solid red' })
											}}
										/>
									</Form.Item>
									{/* {product.name !== 'donation.product.zakat.title' && (
										<Form.Item
											name='gateway'
											label={intl.formatMessage({
												id: 'payment.info.gateway'
											})}
											rules={[
												{
													required: false,
													message: intl.formatMessage({
														id: 'payment.info.gateway.errorMessage'
													})
												}
											]}
										>
											<Select
												defaultValue='sslcommerz'
												// onChange={handleChange}

												options={
													product.name === 'donation.product.monthly.title'
														? [
																// {
																// 	value: 'sslcommerz',
																// 	label: 'SSLCommerz'
																// },
																// {
																// 	value: 'bkash',
																// 	label: 'BKash'
																// },
																{
																	value: 'bkash_recurring',
																	label: 'Subscription by bKash'
																}
														  ]
														: [
																{
																	value: 'sslcommerz',
																	label: 'SSLCommerz'
																}
														  ]
												}
											/>
										</Form.Item>
									)} */}
									{product.name === 'donation.product.monthly.title' &&
										selectedSubscription === 'THIRTY_DAYS' && (
											<Form.Item
												name='gateway'
												required
												label={intl.formatMessage({
													id: 'payment.info.gateway'
												})}
											>
												<RadioGroup
													buttonStyle='solid'
													size='large'
													style={{
														flexDirection: 'column',
														width: '100%',
														paddingBottom: 10
													}}
													defaultValue='bkash_recurring'
													value={selectedMonthlyGateway}
													onChange={e => {
														const getwatValue = e.target.value
														// console.log('target', e.target.value)
														setSelectedMonthlyGateway(getwatValue)
														form.setFieldValue('gateway', getwatValue)
														// console.log('dd', selectedMonthlyGateway)

														// if (selectedSubscription === 'DAILY') {
														// 	// console.log('data')
														// 	handleDonationTabChange(
														// 		getwatValue === 'bkash_recurring' ? 1 : 10,
														// 		'DAILY'
														// 	)
														// }
													}}
												>
													<Radio
														value='bkash_recurring'
														defaultChecked
														button
														style={{
															width: '100%',
															height: 85,
															paddingTop: 5,
															paddingLeft: 15,
															marginBottom: 16,
															border:
																selectedMonthlyGateway === 'bkash_recurring'
																	? '1px solid #018E49'
																	: '1px solid #DBDBDB',
															background:
																selectedMonthlyGateway === 'bkash_recurring'
																	? '#E4FFF2'
																	: 'transparent',
															borderRadius: '4px'
														}}
													>
														<img src={bkash} alt='bkash payment' />
														<p>
															<IntlMessages id='payment.method.option.bkash.auto.pay' />
														</p>
													</Radio>
													<Radio
														value='sslcommerz'
														style={{
															width: '100%',
															height: 85,
															paddingTop: 10,
															paddingLeft: 15,
															border:
																selectedMonthlyGateway === 'sslcommerz'
																	? '1px solid #018E49'
																	: '1px solid #DBDBDB',
															background:
																selectedMonthlyGateway === 'sslcommerz'
																	? '#E4FFF2'
																	: 'transparent',
															borderRadius: '4px'
														}}
													>
														<img
															src={ssl}
															alt='ssl-payment'
															style={{ marginBottom: '4px' }}
														/>
														<p>
															<IntlMessages id='payment.method.option.ssl' />
														</p>
													</Radio>
												</RadioGroup>
											</Form.Item>
										)}

									{product.name === 'donation.product.monthly.title' &&
										selectedSubscription !== 'THIRTY_DAYS' && (
											<Form.Item
												name='gateway'
												required
												label={intl.formatMessage({
													id: 'payment.info.gateway'
												})}
											>
												<RadioGroup
													buttonStyle='solid'
													size='large'
													style={{
														flexDirection: 'column',
														width: '100%',
														paddingBottom: 10
													}}
													defaultValue='bkash_recurring'
													value={selectedMonthlyGateway}
													onChange={e => {
														const getwatValue = e.target.value
														// console.log('target', e.target.value)
														setSelectedMonthlyGateway(getwatValue)
														form.setFieldValue('gateway', getwatValue)
														// console.log('dd', selectedMonthlyGateway)

														if (selectedSubscription === 'DAILY') {
															// console.log('data')
															handleDonationTabChange(
																getwatValue === 'bkash_recurring' ? 1 : 10,
																'DAILY'
															)
														}
													}}
												>
													<Radio
														value='bkash_recurring'
														defaultChecked
														button
														style={{
															width: '100%',
															height: 85,
															paddingTop: 5,
															paddingLeft: 15,
															marginBottom: 16,
															border:
																selectedMonthlyGateway === 'bkash_recurring'
																	? '1px solid #018E49'
																	: '1px solid #DBDBDB',
															background:
																selectedMonthlyGateway === 'bkash_recurring'
																	? '#E4FFF2'
																	: 'transparent',
															borderRadius: '4px'
														}}
													>
														<img src={bkash} alt='bkash payment' />
														<p>
															<IntlMessages id='payment.method.option.bkash.auto.pay' />
														</p>
													</Radio>
												</RadioGroup>
											</Form.Item>
										)}

									{/* {gateway === 'bkash_recurring' ? (
										<Form.Item
											name='subscription'
											label={intl.formatMessage({
												id: 'payment.info.subscription'
											})}
											rules={[
												{
													required: true,
													message: intl.formatMessage({
														id: 'payment.info.subscriptionMessage'
													}),
													whitespace: true
												}
											]}
										>
											<Select
												defaultValue={'DAILY'}
												options={subscriptionFrequencies}
											/>
										</Form.Item>
									) : null} */}
									<Row>
										<Col xl={24} lg={24} md={24} sm={24} xs={24}>
											<div style={{ paddingBottom: 10 }}></div>
											{!checked &&
												product.name === 'donation.product.qurbani.title' &&
												!isNextButtonActive &&
												(cowIncrement > 0 ||
													sharedCowIncrement > 0 ||
													goatIncrement > 0) ? (
												<>
													{/* <Row>
														<Col xl={24} lg={24} md={24} sm={24} xs={24}>
															<Button
																type='primary'
																style={{ float: 'initial' }}
																onClick={() => {
																	if (cowQurbaniNameList.length === 0) {
																		setIsCowQurbaniNamesFormOpen(
																			cowIncrement > 0 ? true : false
																		)
																	}
																	if (sharedCowQurbaniNameList.length === 0) {
																		setIsSharedCowQurbaniNamesFormOpen(
																			sharedCowIncrement > 0 ? true : false
																		)
																	}
																	if (goatQurbaniNameList.length === 0) {
																		setIsGoatQurbaniNamesFormOpen(
																			goatIncrement > 0 ? true : false
																		)
																	}
																	setIsNextButtonActive(true)
																}}
															>
																<IntlMessages id='nav.next.button' />
															</Button>
															<Button
																type='primary'
																htmlType='submit'
																style={{ float: 'right' }}
																disabled={true}
																//block
															>
																<IntlMessages id='payment.info.donateButton' />
															</Button>
														</Col>
													</Row> */}
												</>
											) : product.name === 'donation.product.zakat.title' ? (
												<>
													{isZakatPaymentNextActive || (
														<Button
															type='primary'
															htmlType='button'
															style={{ float: 'right' }}
															onClick={zakatFormNextHandler}
														// disabled={
														// 	!(
														// 		form.getFieldValue('amount') &&
														// 		form.getFieldValue('phoneOrEmail')
														// 	)
														// }
														>
															<IntlMessages id='nav.next.button' />
														</Button>
													)}
												</>
											) : (
												<>
													<Button
														type='primary'
														htmlType='submit'
														loading={loading}
														style={{
															float: 'right'
														}}
														disabled={
															product.name ===
																'donation.product.qurbani.title' ||
																isCowQurbaniNamesFormOpen ||
																isSharedCowQurbaniNamesFormOpen ||
																isGoatQurbaniNamesFormOpen
																? true
																: false
														}
													//block
													>
														<IntlMessages id='payment.info.donateButton' />
													</Button>
												</>
											)}
											{/* {isNextButtonActive &&
											product.name === 'donation.product.qurbani.title' ? (
												<>
													<Button
														type='primary'
														style={{ float: 'initial' }}
														onClick={() => {
															// setCowQurbaniNameList([])
															// setSharedCowQurbaniNameList([])
															// setGoatQurbaniNameList([])
															setIsNextButtonActive(false)
														}}
														//block
													>
														<IntlMessages id='nav.previous.button' />
													</Button>

												</>
											) : null} */}
										</Col>
									</Row>
								</Form>
							)}

							{/* {product.name === 'donation.product.qurbani.title' ? (
								<div>
									<Checkbox
										onChange={onHalalCheckBoxChange}
										checked={isHalal}
										style={{ marginBottom: 20 }}
									>
										<IntlMessages id='qurbani.halal.dialogue' />
									</Checkbox>
								</div>
							) : null} */}
							{/* {product.name !== 'donation.product.zakat.title' &&
								product.name === 'donation.product.monthly.title' &&
								selectedMonthlyGateway !== 'bkash_recurring' && (
									<p style={{ textAlign: 'center' }}>
										<IntlMessages id='payment.agree.1' />
										<a href='/terms-and-condition'>
											<IntlMessages id='payment.terms' />
										</a>
										<IntlMessages id='payment.agree.2' />
										<a href='/privacy-policy'>
											<IntlMessages id='payment.privacy' />
										</a>
										<IntlMessages id='payment.agree.3' />
									</p>
								)} */}
							{product.name !== 'donation.product.zakat.title' &&
								!(
									product.name === 'donation.product.monthly.title' &&
									selectedMonthlyGateway === 'bkash_recurring'
								) && (
									<p style={{ textAlign: 'center' }}>
										<IntlMessages id='payment.agree.1' />
										<a href='/terms-and-condition'>
											<IntlMessages id='payment.terms' />
										</a>
										<IntlMessages id='payment.agree.2' />
										<a href='/privacy-policy'>
											<IntlMessages id='payment.privacy' />
										</a>
										<IntlMessages id='payment.agree.3' />
									</p>
								)}

							{product.name === 'donation.product.monthly.title' &&
								selectedMonthlyGateway === 'bkash_recurring' && (
									<p style={{ textAlign: 'center' }}>
										<IntlMessages id='payment.bkash.auto.pay' />
									</p>
								)}

							{product.name === 'donation.product.monthly.title' && (
								<Typography>
									<Paragraph>
										<IntlMessages id='donation.product.monthly.desc' />
									</Paragraph>
								</Typography>
							)}
						</Card>
						{product.name === 'donation.product.complex.title' &&
							width <= 768 ? (
							<Card
								style={{ marginTop: '30px', width: '100%' }}
								className='gx-card'
							>
								<h1 style={{ textAlign: 'center' }}>
									<IntlMessages id='donation.product.complex.info.title' />
								</h1>
								<p>
									<IntlMessages id='donation.product.complex.info.1' />
								</p>
								<a href='https://forms.gle/XKBzmyYrijKoHdsy8'>
									<p>
										<IntlMessages id='donation.product.complex.info.2' />
									</p>
								</a>
								<p>
									<IntlMessages id='donation.product.complex.info.3' />
								</p>
							</Card>
						) : null}
						{/* {product.name === 'donation.product.monthly.title' && (
							<Card
								style={{ width: '100%' }}
								// className='gx-card'
							>
								<Typography>
									<Paragraph>
										<IntlMessages id='donation.product.monthly.desc' />
									</Paragraph>
								</Typography>
							</Card>
						)} */}
					</Col>
				</Row>

				<div className='qurbani-responsive-card-xs'>
					{product.name === 'donation.product.qurbani.title' && <Qurbani />}
				</div>

				{product.name === 'donation.product.zakat.title' && width < 768 ? (
					<Card
						style={{ marginTop: '21px', width: '100%' }}
					// className='gx-card'
					>
						<p style={{ color: 'green' }}>
							<IntlMessages id='zakat.top.left.header.1' />
						</p>
						<p>
							<IntlMessages id='zakat.top.left.paragraph.1' />
						</p>
						<p>
							<IntlMessages id='zakat.top.left.paragraph.2' />
						</p>
						<p style={{ color: 'green' }}>
							<IntlMessages id='zakat.top.left.paragraph.3' />
						</p>
						<Timeline style={{ paddingTop: 10 }}>
							{/* <Timeline.Item style={{ color: 'green', cursor: 'pointer' }}
										onClick={() => history.push('/link')}
								>
									<IntlMessages id='zakat.top.left.bullet.1' />
								</Timeline.Item> */}
							<Timeline.Item color='green'>
								<Link
									to='/self-reliance-project'
									style={{
										textDecoration: 'underline'
									}}
								>
									<IntlMessages id='zakat.top.left.bullet.1' />
								</Link>
							</Timeline.Item>
							<Timeline.Item color='green'>
								<Link
									to='/scholarships-for-training-unemployed-unskilled'
									style={{
										textDecoration: 'underline'
									}}
								>
									<IntlMessages id='zakat.top.left.bullet.2' />
								</Link>
							</Timeline.Item>
							<Timeline.Item color='green'>
								<IntlMessages id='zakat.top.left.bullet.3' />
							</Timeline.Item>
						</Timeline>
						{/* <p>
										<IntlMessages id='zakat.top.left.paragraph.4' />
									</p> */}
					</Card>
				) : null}

				{/* Contents */}
				{product.name === 'donation.product.iftar.title' ? (
					<Iftar />
				) : product.name === 'donation.product.zakat.title' ? (
					<Zakat />
				) : product.name === 'donation.product.sadaqah.title' ? (
					<Sadaqah />
				) : product.name === 'donation.product.general.title' ? (
					<General />
				) : product.name === 'donation.product.monthly.title' ? (
					<div className='monthly-card-md'>
						<Monthly />
					</div>
				) : product.name === 'donation.product.orphan.title' ? (
					<Orphan />
				) : product.name === 'donation.product.flood.title' ? (
					<div className='flood-card-md'>
						<Flood />
					</div>
				) : product.name === 'donation.product.winter.title' ? (
					<Winter />
				) : product.name === 'donation.product.emergency.title' ? (
					<div className='emergency-card-md'>
						<Emergency />
					</div>
				) : product.namje === 'donation.product.self-reliant.title' ? (
					<SelfReliant />
				) : product.name === 'donation.product.tree-plantation.title' ? (
					<div className='card-view-xs'>
						<TreePlantation />
					</div>
				) : product.name === 'donation.product.complex.title' ? (
					<Complex />
				) : product.name ===
					'donation.product.skill-development-institute.title' ? (
					<SkillDevelopment />
				) : null}
				<div>{modalContext}</div>
			</div>
		</div>
	)
}

export default injectIntl(Donate)
